export const COLUMN_TO_INCIDENT_FIELD_MAP: Record<string, string> = {
  severity: 'SEVERITY',
  assignee: 'ASSIGNEE',
  status: 'STATUS',
  database: 'DB',
  schema: 'SCHEMA',
};

export const RESOLVED_STATUS = 'Resolved';

export const STATUS_GROUP_VALUES = [
  'Open',
  'Acknowledged',
  RESOLVED_STATUS,
] as const;

export const SEVERITY_DISPLAY: Record<string, string> = {
  low: 'Low',
  normal: 'Normal',
  high: 'High',
  critical: 'Critical',
};

export const STATUS_DISPLAY: Record<string, string> = {
  open: 'Open',
  acknowledged: 'Acknowledged',
  resolved: 'Resolved',
};
